import { render, staticRenderFns } from "./WorkExperience.vue?vue&type=template&id=b72c7010&scoped=true"
import script from "./WorkExperience.vue?vue&type=script&lang=js"
export * from "./WorkExperience.vue?vue&type=script&lang=js"
import style0 from "./WorkExperience.vue?vue&type=style&index=0&id=b72c7010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72c7010",
  null
  
)

export default component.exports